/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-10 16:19:59
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 00:33:50
 * @FilePath: /wemeet-web-activity/src/pages/tickets/hooks/usePrice.ts
 * @Description: 最终购买价格计算
 */
import { useMemo } from 'react';
const usePrice = (ticket, coupon, canPayCoupon) => {
  const {
    realPrice,
    originPrice,
    couponPrice
  } = useMemo(() => {
    if (!ticket) {
      return {
        realPrice: '',
        originPrice: '',
        couponPrice: ''
      };
    }
    let realPrice = ((ticket.discount_price || 0) / 100).toFixed(2);
    let originPrice = '';
    const couponValue = (coupon || canPayCoupon)?.coupon_value;
    const couponPrice = (((ticket.discount_price || 0) - (coupon?.coupon_value || 0)) / 100).toFixed(2);
    if (couponValue) {
      originPrice = realPrice;
      realPrice = (((ticket.discount_price || 0) - (couponValue || 0)) / 100).toFixed(2);
      return {
        realPrice,
        originPrice,
        couponPrice
      };
    }
    return {
      realPrice,
      originPrice,
      couponPrice
    };
  }, [coupon, ticket, canPayCoupon]);
  return {
    realPrice,
    originPrice,
    couponPrice
  };
};
export default usePrice;